import React, { useEffect, useState } from 'react'
import { X, ShieldCheck, Save } from 'lucide-react'
import { api } from '../services/api'

const groups = {
  Visualizar: [
    'ver_pessoa','ver_instituicao','ver_funcionario','ver_evento','ver_atendimento','ver_emenda','ver_elaboracao_oficio','ver_elaboracao_declaracao','ver_tag','ver_cargo','ver_profissao','ver_tipo_atendimento','ver_area_atendimento','ver_executora','ver_regiao','ver_status_atendimento','ver_status_oficio','ver_configuracao','ver_veiculo_comunicacao','ver_clipping','ver_agenda','ver_bot','ver_cieletronica','ver_projeto_lei','ver_convite_oficio','ver_financeiro','ver_diarias','ver_minha_comunidade','ver_documentacao','ver_requerimento','ver_formulario'
  ],
  Editar: [
    'editar_pessoa','editar_instituicao','editar_funcionario','editar_evento','editar_atendimento','editar_emenda','editar_elaboracao_oficio','editar_elaboracao_declaracao','editar_tag','editar_cargo','editar_profissao','editar_tipo_atendimento','editar_area_atendimento','editar_executora','editar_regiao','editar_status_atendimento','editar_status_oficio','editar_configuracao','editar_veiculo_comunicacao','editar_clipping','editar_agenda','editar_cieletronica','editar_projeto_lei','editar_convite_oficio','editar_financeiro','editar_diarias','editar_minha_comunidade','editar_documentacao','editar_requerimento','editar_formulario'
  ]
}

const PermissoesModal = ({ isOpen, onClose, funcionario }) => {
  const [loading, setLoading] = useState(false)
  const [permissoes, setPermissoes] = useState({})

  useEffect(() => {
    if (isOpen && funcionario) {
      loadPermissoes()
    }
  }, [isOpen, funcionario])

  const loadPermissoes = async () => {
    setLoading(true)
    try {
      const res = await api.get(`/permissoes/get.php`, { id_funcionario: funcionario.id_funcionario })
      if (res.ok) {
        setPermissoes(res.data || {})
      } else {
        setPermissoes({})
      }
    } finally {
      setLoading(false)
    }
  }

  const togglePerm = (key) => {
    setPermissoes(prev => ({ ...prev, [key]: prev[key] === 'sim' ? 'nao' : 'sim' }))
  }

  const setGroupAll = (groupName, value = 'sim') => {
    const keys = groups[groupName] || []
    setPermissoes(prev => {
      const next = { ...prev }
      keys.forEach(k => { next[k] = value })
      return next
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      await api.post('/permissoes/upsert.php', { id_funcionario: funcionario.id_funcionario, ...permissoes })
      onClose()
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-900 rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white flex items-center gap-2">
            <ShieldCheck className="h-5 w-5" />
            Permissões de {funcionario?.nome}
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
            <X className="h-6 w-6" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="flex flex-wrap items-center justify-end gap-2">
            <button type="button" onClick={() => setGroupAll('Visualizar', 'sim')} disabled={loading} className="btn-outline">
              Selecionar todos Ver
            </button>
            <button type="button" onClick={() => setGroupAll('Editar', 'sim')} disabled={loading} className="btn-outline">
              Selecionar todos Editar
            </button>
          </div>
          {Object.entries(groups).map(([groupName, keys]) => (
            <div key={groupName} className="border border-gray-200 dark:border-gray-700 rounded-lg">
              <div className="px-4 py-2 font-medium text-gray-700 dark:text-gray-300">
                {groupName}
                {groupName === 'Editar' && (
                  <div className="mt-1 text-xs text-amber-600">
                    Ao habilitar editar, usuario sera capaz de editar e excluir aquele que for permitido
                  </div>
                )}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 p-4">
                {keys.map((key) => (
                  <label key={key} className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                    <input type="checkbox" checked={(permissoes[key] || 'nao') === 'sim'} onChange={() => togglePerm(key)} />
                    {key.replace(/_/g, ' ')}
                  </label>
                ))}
              </div>
            </div>
          ))}

          <div className="flex items-center justify-end pt-4 border-t border-gray-200 dark:border-gray-700">
            <button type="button" onClick={onClose} disabled={loading} className="btn-outline mr-2">Cancelar</button>
            <button type="submit" disabled={loading} className="btn-primary">
              <Save className="h-4 w-4 mr-2" />
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default PermissoesModal